import { call, put, takeLatest } from 'redux-saga/effects';

import * as actions from './documentMasterActions';
import * as types from './documentMasterActionType';
import documentTypeService from './documentMasterServices';
import SweetAlert from '../../../components/sweetalert/SweetAlert';
import { getNavigate } from '../../../utils/history';


function* fetchDocumentTypesSaga(action) {
  try {
    const response = yield call(documentTypeService.fetchDocumentTypes, action.payload);

    yield put(actions.getDocumentTypesSuccess({
      documentTypes: response.data.documentTypes,
      totalRecords: response.data.totalRecords
    }));
  } catch (error) {
    yield put(actions.getDocumentTypesFailure(error));
  }
}




function* saveDocumentTypeSaga(action) {
    try {
        const response = yield call(documentTypeService.saveDocumentType, action.payload);

        if (response.status || response.data) {
            yield put(actions.saveDocumentTypeSuccess(response.data));

            yield call(() =>
                SweetAlert.success({
                    title: 'Success!',
                    text: 'Document type saved successfully',
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    confirmButtonColor: '#28a745',
                })
            );

            const navigate = getNavigate();
            navigate(-1);
        } else {
            yield put(
                actions.saveDocumentTypeFailure(
                    response.responseMessage || 'Save failed'
                )
            );
        }
    } catch (error) {
        yield put(actions.saveDocumentTypeFailure(error));
    }
}


function* deleteDocumentTypeSaga(action) {
    try {
        // Ensure payload uses correct key for API
        const response = yield call(documentTypeService.deleteDocumentType, {
            DocumentTypeID: action.payload.documentTypeID
        });
        // Always refresh list after delete with default paging
        yield put(actions.getDocumentTypesRequest({ PageNumber: 1, PageSize: 10, SearchText: '', sortColumn: 'DocumentTypeID', sortColumnDir: 'DESC' }));
    } catch (error) {
        yield put(actions.deleteDocumentTypeFailure(error));
    }
}


function* getDocumentTypeByIdSaga(action) {
    try {
 const response = yield call(
            documentTypeService.getDocumentTypeById,
            { DocumentTypeID: action.payload.DocumentTypeID }
        );
                yield put(actions.getDocumentTypeByIdSuccess(response.data));
    } catch (error) {
        yield put(actions.getDocumentTypeByIdFailure(error));
    }
}

export default function* watchDocumentTypeSaga() {
    yield takeLatest(types.GET_DOCUMENT_TYPES_MASTER_REQUEST, fetchDocumentTypesSaga);
    yield takeLatest(types.SAVE_DOCUMENT_TYPE_REQUEST, saveDocumentTypeSaga);
    yield takeLatest(types.DELETE_DOCUMENT_TYPE_REQUEST, deleteDocumentTypeSaga);
    yield takeLatest(types.GET_DOCUMENT_TYPE_BY_ID_REQUEST, getDocumentTypeByIdSaga);
}
